import Vue from "vue";
import VueRouter from "vue-router";
import authGuard from "../router/authGuard";
import store from "@/store";
import { clearRegistrationIntent } from "@/views/V2/olimpiadas/registrationFlow";

import Home from "../views/Home/Home.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Dashboard from "../views/Dashboard.vue";
import VerifyEmail from "../views/VerifyEmail.vue";
import Exercise from "../views/Exercise.vue";
import ExerciseSimulacrum from "../views/ExerciseSimulacrum.vue";
import SimulacrumResult from "../views/SimulacrumResult.vue";
import ExerciseResult from "../views/ExerciseResult.vue";
import CategoryAdmin from "../views/Admin/Components/Category/CategoryAdmin.vue";
import CategoryCreate from "../views/Admin/Components/Category/CategoryCreate.vue";
import OlympicsAdmin from "../views/Admin/Components/Olympics/OlympicsAdmin.vue";
import OlympicsCreate from "../views/Admin/Components/Olympics/OlympicsCreate.vue";
import LessonsAdmin from "../views/Admin/Components/Lessons/LessonsAdmin.vue";
import LessonsCreate from "../views/Admin/Components/Lessons/LessonsCreate.vue";
import ExamsAdmin from "../views/Admin/Components/Exams/ExamsAdmin.vue";
import ExamsCreate from "../views/Admin/Components/Exams/ExamsCreate.vue";
import TagsAdmin from "../views/Admin/Components/Tags/TagsAdmin.vue";
import TagsCreate from "../views/Admin/Components/Tags/TagsCreate.vue";
import PracticesAdmin from "../views/Admin/Components/Practices/PracticesAdmin.vue";
import PracticesCreate from "../views/Admin/Components/Practices/PracticesCreate.vue";
import OauthRegister from "../views/OauthRegister.vue";
import RecoverPassword from "../views/RecoverPassword.vue";
import ChangePassword from "../views/ChangePassword.vue";
import TermsAndConditions from "../views/TermsAndConditions.vue";
import UsersAdmin from "../views/Admin/Components/Users/UsersAdmin.vue";
import SimulacrumsAdmin from "../views/Admin/Components/Simulacrums/SimulacrumAdmin.vue";
import SimulacrumsCreate from "../views/Admin/Components/Simulacrums/SimulacrumCreate.vue";
import UsersCreate from "../views/Admin/Components/Users/UserCreate.vue";
import QuestionsAdmin from "../views/Admin/Components/Questions/QuestionsAdmin.vue";
import QuestionsCreate from "../views/Admin/Components/Questions/QuestionsCreate.vue";
import ExercisePreview from "../views/Admin/Components/Questions/ExercisePreview.vue";
import CourseAdmin from "../views/Admin/Components/Course/CourseAdmin.vue";
import CourseCreate from "../views/Admin/Components/Course/CourseCreate.vue";
import AdminLayout from "../views/Admin/AdminLayout.vue";
import SubcategoriesAdmin from "../views/Admin/Components/Subcategories/SubcategoriesAdmin.vue";
import SubcategoriesCreate from "../views/Admin/Components/Subcategories/SubcategoriesCreate.vue";
import AppV1 from "@/views/AppV1.vue";

// V2 Views
import AppV2 from "@/views/V2/AppV2.vue";
import HomeV2 from "@/views/V2/home/HomeV2.vue";
import DashboardV2 from "@/views/V2/dashboard/DashboardV2.vue";
import PaymentResponse from "@/views/V2/payment-premium/PaymentResponse.vue";
import UserSettings from "@/views/V2/settings/UserSettings.vue";
import Statistics from "@/views/V2/statistics/Statistics.vue";
import courseRoutes from "./course-routes.js";
import authRoutes from "./auth-routes.js";
import Infographic from "@/views/V2/home/Infographic.vue";
import TeacherLayout from "@/views/V2/teacher/TeacherLayout.vue";
import TeacherGroups from "@/views/V2/teacher/TeacherGroups.vue";
import TeacherRequests from "@/views/V2/teacher/TeacherRequests.vue";
import TeacherInstitutions from "@/views/V2/teacher/TeacherInstitutions.vue";
import ContestsList from "@/views/V2/olimpiadas/ContestsList.vue";
import ContestsListOlimpiadas1 from "@/views/V2/olimpiadas/ContestsListOlimpiadas1.vue";
import ContestsListOlimpiadas2 from "@/views/V2/olimpiadas/ContestsListOlimpiadas2.vue";
import OlimpiadasProfile from "@/views/V2/olimpiadas/OlimpiadasProfile.vue";
import OlimpiadasPhaseRanking from "@/views/V2/olimpiadas/OlimpiadasPhaseRanking.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/old/",
    component: AppV1,
    children: [
      {
        path: "/",
        name: "Home",
        component: HomeV2,
      },
      {
        path: "/login",
        name: "Login",
        component: Login,
      },
      {
        path: "/register",
        name: "Register",
        component: Register,
      },
      {
        path: "/recover-password",
        name: "RecoverPassword",
        component: RecoverPassword,
      },
      {
        path: "/change-password/:token",
        name: "ChangePassword",
        component: ChangePassword,
        props: true,
      },
      {
        path: "/verify-email/:token",
        name: "VerifyEmail",
        component: VerifyEmail,
        props: true,
      },
      {
        path: "/terms-and-conditions",
        name: "TermsAndConditions",
        component: TermsAndConditions,
        props: true,
      },
      {
        path: "/old/dashboard",
        name: "Dashboard",
        component: Dashboard,
        // beforeEnter: authGuard,
      },
      {
        path: "/exercise/:topic",
        name: "Exercise",
        component: Exercise,
        props: true,
      },
      {
        path: "/simulacrum/:topic",
        name: "Simulacrum",
        component: ExerciseSimulacrum,
        props: true,
      },
      {
        path: "/simulacrumResult/:id",
        name: "SimulacrumResult",
        component: SimulacrumResult,
        props: true,
      },
      {
        path: "/exercise-result/",
        name: "ExerciseResult",
        component: ExerciseResult,
        props: (route) => ({
          topic: route.query.topic,
          total: route.query.total,
          correct: route.query.correct,
        }),
      },
      {
        path: "/oauth2/redirect",
        name: "Oath2Redirect",
        component: OauthRegister,
      },
    ],
  },
  {
    path: "/",
    name: "V2",
    component: AppV2,
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: ContestsListOlimpiadas1,
        name: "Home",
        meta: {
          title: "Home",
        },
      },
      {
        path: "/explore",
        component: Home,
        name: "Explore",
        meta: {
          title: "Explorar",
        },
      },
      {
        path: "/olimpiadas",
        component: ContestsListOlimpiadas1,
        name: "ContestsList",
        meta: {
          title: "Olimpiadas",
        },
      },
      {
        path: "/olimpiadas1",
        redirect: "/olimpiadas",
      },
      {
        path: "/olimpiadas-blue",
        component: ContestsList,
        name: "ContestsListOlimpiadasBlue",
        meta: {
          title: "Olimpiadas (blue)",
        },
      },
      {
        path: "/olimpiadas2",
        component: ContestsListOlimpiadas2,
        name: "ContestsListOlimpiadas2",
        meta: {
          title: "Olimpiadas (design v2)",
        },
      },
      {
        path: "/olimpiadas/profile",
        component: OlimpiadasProfile,
        name: "OlimpiadasProfile",
        meta: {
          title: "Olimpiadas",
        },
      },
      {
        path: "/olimpiadas/:slug/fases/:phaseId/ranking",
        component: OlimpiadasPhaseRanking,
        name: "OlimpiadasPhaseRanking",
        meta: { title: "Ranking" },
      },
      {
        path: "/olimpiadas/id/:olympicId/fases/:phaseId/ranking",
        component: OlimpiadasPhaseRanking,
        name: "OlimpiadasPhaseRankingById",
        meta: { title: "Ranking" },
      },
      {
        path: "/olimpiadas/:slug",
        redirect: "/olimpiadas",
      },
      {
        path: "/infographic",
        component: Infographic,
        name: "Infographic",
      },
      {
        path: "/dashboard",
        component: DashboardV2,
        name: "DashboardV2",
        beforeEnter: (to, from, next) => {
          authGuard(to, from, () => {
            const role = window.localStorage.getItem("role");
            if (role === "ROLE_ACADEMIC_ADMIN") {
              next("/teacher/groups");
              return;
            }
            next();
          });
        },
        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "/v2/settings",
        component: UserSettings,
        name: "UserSettings",
        beforeEnter: authGuard,
        meta: {
          title: "Configuración",
        },
      },
      {
        path: "/payment-response",
        component: PaymentResponse,
        name: "PaymentResponse",
      },
      {
        path: "/statistics",
        component: Statistics,
        name: "Statistics",
        beforeEnter: authGuard,
        meta: {
          title: "Estadísticas",
        },
      },
      {
        path: "/student-performance-summary",
        component: () => import("@/views/V2/statistics/StudentPerformanceSummary.vue"),
        name: "StudentPerformanceSummary",
        beforeEnter: authGuard,
        meta: {
          title: "Student Performance Summary",
        },
      },
      courseRoutes,
      authRoutes,
    ],
  },
  {
    path: "/teacher",
    component: TeacherLayout,
    redirect: "/teacher/groups",
    beforeEnter: (to, from, next) => {
      authGuard(to, from, () => {
        const role = window.localStorage.getItem("role");
        if (role !== "ROLE_ACADEMIC_ADMIN") {
          next("/dashboard");
          return;
        }
        next();
      });
    },
    children: [
      {
        path: "/teacher/groups",
        component: TeacherGroups,
        name: "TeacherGroups",
        meta: { title: "Mis grupos" },
        beforeEnter: (to, from, next) => {
          const role = window.localStorage.getItem("role");
          const institutions = JSON.parse(
            window.localStorage.getItem("teacher_institutions") || "[]"
          );
          if (role === "ROLE_ACADEMIC_ADMIN" && institutions.length === 0) {
            next("/teacher/institutions");
            return;
          }
          next();
        },
      },
      {
        path: "/teacher/requests",
        component: TeacherRequests,
        name: "TeacherRequests",
        meta: { title: "Solicitudes" },
      },
      {
        path: "/teacher/institutions",
        component: TeacherInstitutions,
        name: "TeacherInstitutions",
        meta: { title: "Administrar instituciones" },
      },
      {
        path: "/teacher/students/:studentId/report",
        component: Statistics,
        name: "TeacherStudentReport",
        props: (route) => ({ viewingStudentId: route.params.studentId }),
        meta: { title: "Reporte del estudiante" },
      },
    ],
  },
  {
    path: "/admin-panel",
    component: AdminLayout,
    redirect: "/admin-panel/questions",
    children: [
      {
        path: "/admin-panel/users",
        component: UsersAdmin,
        name: "UsersAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/simulacrums",
        component: SimulacrumsAdmin,
        name: "SimulacrumsAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/simulacrums/create",
        component: SimulacrumsCreate,
        name: "SimulacrumsCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/simulacrums/edit/:id",
        component: SimulacrumsCreate,
        name: "SimulacrumsEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/users/edit/:id",
        component: UsersCreate,
        name: "UsersEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/questions",
        component: QuestionsAdmin,
        name: "QuestionsAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/questions/create",
        component: QuestionsCreate,
        name: "QuestionsCreate",
        meta: { template: "admin-layout" },
        props: true,
      },
      {
        path: "/admin-panel/questions/:id",
        component: QuestionsCreate,
        name: "QuestionsEdit",
        meta: { template: "admin-layout" },
        props: true,
      },
      {
        path: "/admin-panel/questions/preview/:id",
        component: ExercisePreview,
        name: "QuestionsPreview",
        meta: { template: "admin-layout" },
        props: true,
      },
      {
        path: "/admin-panel/lecciones",
        component: LessonsAdmin,
        name:"LeccionesAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Lecciones/edit/:id",
        component: LessonsCreate,
        name:"LessonsEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/lecciones/create",
        component: LessonsCreate,
        name:"LessonsCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/cursos",
        component: CourseAdmin,
        name:"CursosAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/cursos/edit/:id",
        component: CourseCreate,
        name: "CourseEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/cursos/create",
        component: CourseCreate,
        name: "CourseCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/categorias",
        component: CategoryAdmin,
        name:"CategoríasAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/categorias/edit/:id",
        component: CategoryCreate,
        name: "CategoryEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/categorias/create",
        component: CategoryCreate,
        name: "CategoryCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/olimpiadas",
        component: OlympicsAdmin,
        name: "OlimpiadasAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/olimpiadas/edit/:id",
        component: OlympicsCreate,
        name:"OlympicsEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/olimpiada/create",
        component: OlympicsCreate,
        name:"OlympicsCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Practices",
        component: PracticesAdmin,
        name:"Practices",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Practices/create",
        component: PracticesCreate,
        name:"PracticesCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Practices/:id",
        component: PracticesCreate,
        name:"PracticesEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Exams",
        component: ExamsAdmin,
        name:"ExamsAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Exams/create",
        component: ExamsCreate,
        name:"ExamsCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Exams/:id",
        component: ExamsCreate,
        name:"ExamsEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Tags",
        component: TagsAdmin,
        name:"TagsAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Tags/create",
        component: TagsCreate,
        name:"TagsCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Tags/:id",
        component: TagsCreate,
        name:"TagsEdit",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Subcategories",
        component: SubcategoriesAdmin,
        name: "SubcategoriesAdmin",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Subcategories/create",
        component: SubcategoriesCreate,
        name: "SubcategoriesCreate",
        meta: { template: "admin-layout" },
      },
      {
        path: "/admin-panel/Subcategories/edit/:id",
        component: SubcategoriesCreate,
        name: "SubcategoriesEdit",
        meta: { template: "admin-layout" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: import.meta.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `Mobius | ${to.meta.title}` : "Mobius";

  // Clear Olimpiadas registration intent when leaving to explore (user chose not to complete auth)
  if (to.path === "/explore") {
    clearRegistrationIntent();
  }

  // Guardar la ruta anterior si existe (evita guardar rutas vacías al inicio)
  if (from.fullPath) {
    // Usar router.app.$store si está disponible (después de que la app esté montada),
    // de lo contrario usar el store importado directamente
    const storeInstance = router.app?.$store || store;
    storeInstance.commit("SET_PREVIOUS_ROUTE", from.fullPath);
  }

  next();
});

export default router;
